<template>
    <div class="page-icon" :class="'page-icon-' + size">
        <span :style="{ backgroundImage: image, backgroundPosition:'center' }" :class="'container-' + (image && image.length ? '' : color)">
            <template v-if="!image">{{ text }}</template>            
        </span>

    </div>
</template>
<script>
export default {
    props : {
       image : {
           type : String
       },
       text : {
           type : String,
           default: ""
       },
       color : {
           type : String,
           default: "white"
       },
       size: {
           type: String,
           default: 'md'
       }
    }
}
</script>